/**
 * The slim app header: app name, signed-in valuer's name, sign out. Nothing else —
 * this is a two-screen app for valuers (see the plan / DESIGN.md).
 */
import { Button } from './ui';

interface HeaderProps {
  userName: string | null;
  onSignOut: () => void;
  /** Phase 6: shown only for accounts with app_metadata.is_admin = true. */
  showAdminLink?: boolean;
  onOpenAdmin?: () => void;
}

export function Header({ userName, onSignOut, showAdminLink, onOpenAdmin }: HeaderProps) {
  return (
    <header className="header">
      <span className="header__brand">Valuation QA</span>
      <div className="header__right">
        {userName ? <span className="header__user">{userName}</span> : null}
        {showAdminLink ? (
          <Button variant="ghost" onClick={onOpenAdmin}>
            Admin
          </Button>
        ) : null}
        <Button variant="ghost" onClick={onSignOut}>
          Sign out
        </Button>
      </div>
    </header>
  );
}
